import React, {
    useContext,
    useEffect,
} from 'react';
import { useQuery, useMutation } from '@tanstack/react-query';

import { refetchBasketData, NotificationContext, handleError } from '../router';

import * as OPTIONS from "../option-fields";
import * as QUERIES from "../query-functions";

import LoadingIndicator from '../components/loading-indicator';

const membershipId = OPTIONS.discountAvailable.membership?.innerHTML;

export default function SavingsPrompt(props) {
    const { notification, setNotification } = useContext(NotificationContext);

    const {
        isFetching: isPotentialDiscountDataFetching,
        data: potentialDiscountData,
        refetch: refetchPotentialDiscountData,
    } = useQuery({
        queryKey: ['potentialDiscountData', membershipId],
        queryFn: () => QUERIES.getPotentialDiscount(membershipId),
        refetchOnWindowFocus: false,
        retry: false
    });

    const addMembership = useMutation({
        mutationFn: () => QUERIES.addMembership([{ membership: membershipId, autoRenew: true }]),
        onError: (error) => {
            handleError(error.message, setNotification);
        },
        onSuccess: () => {
            refetchBasketData();
            refetchPotentialDiscountData();
        },
    });

    // Refetch discount data when basketData changes
    useEffect(() => {
        if (props.basketData) {
            refetchPotentialDiscountData();
        }
    }, [props.basketData, refetchPotentialDiscountData]);

    // console.log('saved', potentialDiscountData);

    if (!props.basketData || isPotentialDiscountDataFetching || !potentialDiscountData?.totalDiscount) return null;

    return (
        <section className='membership-prompt'>
            <div className='membership-prompt--inner'>
                <h3 className='booking-pathway__header'>
                    {`You’ve saved £${potentialDiscountData.totalDiscount.toFixed(2)} on your order today as a member.`}
                </h3>
                {OPTIONS.membershipsSavingsMessage.text && (
                    <div
                        className='membership-prompt--description'
                        dangerouslySetInnerHTML={{ __html: OPTIONS.membershipsSavingsMessage.text.innerHTML }}
                    />
                )}
            </div>
        </section>
    );
}
